/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.PosHardware {
    import DeviceTypeEnum = Meevo.Model.DeviceTypeEnum;
    import Device = Meevo.Model.Device;

    "use strict";

    export class PosHardwareContext extends Meevo.Components.CommonClasses.CommonContextBase {
        protected changeAccessSecurityKey: string;
        protected changeOwnerSecurityKey: string;
        protected printerBrands: any; // Drop Down List
        protected creditCardBrands: any; // Drop Down List
        protected regexIp: string;
        protected checkForm: boolean;
        protected $q: ng.IQService;
        protected merchantAccounts: Model.MerchantAccount[];
        protected merchantAccountTerminals: any;
        protected nullValue: any;

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            protected printService: Meevo.Components.Common.IPrintService,
            q: ng.IQService,
            protected $rootScope: angular.IRootScopeService,
            protected $state: any,
            private $translate: angular.translate.ITranslateService
        ) {
            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);

            this.$q = q;
            this.checkForm = false;
            this.todayDate = moment().startOf("day").toDate();
            // initialize end points
            this.baseEndpoint = appSettings.API_ENDPOINTS.posHardware;
            // initialize templatepaths
            this.sectionTemplatePath = "app/plugins/posHardware/sectionViews/";
            this.initializeSections();
            this.regexIp = "^([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.([01]?\\d\\d?|2[0-4]\\d|25[0-5])$";
            this.editSecurityKey = "REGISTER:POSHARDWARE:TAB:RECEIPTPRINTER:WRITE";
            this.addSecurityKey = "REGISTER:POSHARDWARE:TAB:RECEIPTPRINTER:CREATE";
            this.deleteSecurityKey = "REGISTER:POSHARDWARE:TAB:RECEIPTPRINTER:DELETE";
            this.nullValue = null;
        }

        initializeSections(): void {

            // Adding sections items that represent areas in the maintenance form
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.REGISTER_POSHARDWARE_TAB_RECEIPTPRINTER +
                Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new MainSection(0,
                    "SECTION_POSHARDWARE_RECEIPTPRINER",
                    "receiptPrinter.html",
                    true,
                    false,
                    this.baseEndpoint,
                    "Printer/List",
                    this.loggingService,
                    this.dataService,
                    Meevo.Model.NounEnum.PosHardwareReceiptPrinter,
                    this.identityService, this.securityKeys.REGISTER_POSHARDWARE_TAB_RECEIPTPRINTER +
                    Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.REGISTER_POSHARDWARE_TAB_POSSTATION +
                Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new PosStationSection(1,
                    "SECTION_DRAWER_POS_STATIONS",
                    "posStation.html",
                    true,
                    false,
                    this.baseEndpoint,
                    "PosStation/List",
                    this.loggingService,
                    this.dataService,
                    Meevo.Model.NounEnum.PosHardwarePosStation,
                    this.identityService,
                    this.securityKeys.REGISTER_POSHARDWARE_TAB_POSSTATION +
                    Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            this.sections[0].model = { devices: new Array<Device>(), deviceType: DeviceTypeEnum.Printer };
            //this.sections[1].model = { devices: new Array<Device>(), deviceType: DeviceTypeEnum.CreditCard };
            this.sections[1].model = { devices: new Array<Device>(), deviceType: DeviceTypeEnum.PosStation };

            this.dataService.customMethodData("api/PosHardware/Brands", "POST", { DeviceType: 2274 })
                .then((data) => {
                    this.printerBrands = data.data;
                });

            this.dataService.customMethodData("api/PosHardware/Brands", "POST", { DeviceType: 2275 })
                .then((data) => {
                    this.creditCardBrands = data.data;
                });

            this.dataService.customMethodData("/api/location/merchantProviders", "GET", null).then((response) => {
                const providers = response.data;
                
                this.dataService.customMethodData("api/MerchantAccount/List", "POST", {
                    criteria: {
                        includeHostedPage: true
                    }
                }).then((data) => {
                    this.merchantAccounts = data.data.filter(merchantAccount => 
                        merchantAccount.merchantProviderId !== Model.MerchantAccountProviderEnum.CareCredit);
                    this.merchantAccountTerminals = [];

                    if (!this.merchantAccounts) {
                        return;
                    }

                    // loop through merchant accounts & concatenate the display names from Accounts & Terminals
                    for (const merchantAccount of this.merchantAccounts) {
                        if (!merchantAccount.terminals) {
                            continue;
                        }

                        const provider = providers.find(provider => provider.id === merchantAccount.merchantProviderId);

                        for (const merchantTerminal of merchantAccount.terminals) {
                            switch (merchantTerminal.merchantTerminalType) {
                                case Meevo.Model.MerchantTerminalTypeEnum.Physical:
                                    merchantTerminal.displayName = `${merchantAccount.displayName}:${merchantTerminal.displayName}`;
                                    break;

                                case Meevo.Model.MerchantTerminalTypeEnum.Hosted:
                                    if (this.merchantAccountTerminals.some(terminal => terminal.id === merchantTerminal.id)) {
                                        continue;
                                    }
                                    merchantTerminal.displayName = `${provider.displayName}:${this.$translate.instant("LABEL_HOSTED_PAGE")}`;
                                    break;
                            }
                            this.merchantAccountTerminals.push(merchantTerminal);
                        }
                    }
                });
            });

            this.activate();
        }

        initializeHeader(model: any): void {
        }

        edit() {
            super.edit();
            this.checkForDuplicateIpAddress();
        }        

        isPrinterDataValid(index: number): boolean {
            if (!this.selectedSection.model || !this.selectedSection.model.devices) {
                return false;
            }

            const device = this.selectedSection.model.devices[index];

            if (!device) {
                return false;
            }

            if (!device.ipAddress) {
                return false;
            }

            if (this.isEpsonBrand(device.brandId) && (!device.deviceName || !device.port)) {
                return false;
            }

            if (this.isStarBrand(device.brandId) && (!device.ribbonSize)) {
                return false;
            }

            return true;
        }

        isCreditCardDataValid(index: number): boolean {
            if (!this.selectedSection.model || !this.selectedSection.model.devices) {
                return false;
            }

            const device = this.selectedSection.model.devices[index];

            if (!device) {
                return false;
            }

            if (!device.terminalId || !device.port || !device.ipAddress) {
                return false;
            }

            return true;
        }

        setCookie(stationId: string, numDaysToExpiration: number): void {
            this.dataService.customMethodData(`api/PosHardware/Device/${stationId}/Cookie?numDaysToExpiration=${numDaysToExpiration}`, "GET", "");
        }

        getCookie(cname: string): string {
            const name = cname + "=";
            const ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }

        isPOSActive(stationId: string): boolean {
            if (this.getCookie("POSStation") != "" && this.getCookie("POSStation") == stationId) {
                return true;
            } else {
                return false;
            }
        }

        activePOSStation(stationId: any): void {
            if (stationId != null) {
                this.setCookie(stationId, 3650); // creates a cookie which expires in 10 years
            } else {
                this.modalService.alert("POS Station must be saved before it can be activated", 0);
            }
        }

        addPrinter(): void {
            if (!this.isReadonly) {
                this.sections[0].model.devices.push({
                    id: null,
                    brandId: null,
                    deviceName: "",
                    ribbonSize: 3,
                    displayName: "",
                    ipAddress: "",
                    port: null,
                    objectState: Meevo.Model.ObjectStateEnum.Active,
                    terminalId: null,
                    entityVersion: 0,
                    devicePrinterId: null,
                    deviceCardId: null,
                    deviceType: DeviceTypeEnum.Printer,
                    useNetworkPrinter: false,
                    drawer: null,
                    customerDisplayStandbyLine1: null,
                    customerDisplayStandbyLine2: null,
                    isCustomerDisplayEnabled: false,
                    isTrustEnabled: false,
                });
            }
        }

        addPosStation(): void {
            if (!this.isReadonly) {
                this.sections[1].model.devices.push({
                    id: null,
                    brandId: null,
                    deviceName: "",
                    ribbonSize: 3,
                    displayName: "",
                    ipAddress: null,
                    port: null,
                    objectState: Meevo.Model.ObjectStateEnum.Active,
                    terminalId: null,
                    entityVersion: 0,
                    devicePrinterId: null,
                    deviceCardId: null,
                    deviceType: DeviceTypeEnum.PosStation,
                    useNetworkPrinter: false,
                    drawer: null,
                    customerDisplayStandbyLine1: null,
                    customerDisplayStandbyLine2: null,
                    isCustomerDisplayEnabled: false,
                    isTrustEnabled: false,
                });
            }
        }

        isDisabled(device) {
            if (this.isReadonly) {
                return true;
            }
            if (device.objectState !== Meevo.Model.ObjectStateEnum.Active) {
                return true;
            }
            return false;
        }

        isIpAddressInvalid(device) {
            if (this.isReadonly) {
                return false;
            }
            if (device.objectState !== Meevo.Model.ObjectStateEnum.Active) {
                return false;
            }
            if (device.validState) {
                return false;
            }
            return true;
        }

        checkForDuplicateIpAddress(): void {
            if (!this.selectedSection) {
                return;
            }

            const devices = this.selectedSection.model.devices;

            for (let i = 0; i < devices.length; i++) {
                devices[i].validState = true;

                if (devices[i].objectState !== Meevo.Model.ObjectStateEnum.Active) {
                    continue;
                }

                if (devices[i].deviceType !== DeviceTypeEnum.Printer) {
                    continue;
                }                

                if (!devices[i].ipAddress) {
                    devices[i].validState = false;
                    continue;
                }

                for (let j = 0; j < devices.length; j++) {
                    if (devices[j].objectState !== Meevo.Model.ObjectStateEnum.Active) {
                        continue;
                    }

                    if (devices[i] === devices[j]) {
                        continue;
                    }

                    if (devices[i].ipAddress == devices[j].ipAddress) {
                        devices[i].validState = false;
                        break;
                    }
                }
            }

            if (this.isTheFormInvalid()) {
                return;
            }

            this.checkForm = false;
        }

        isTheFormInvalid(): boolean {
            return _(this.selectedSection.model.devices).any((device) => !this.isDisabled(device) && device.validState === false);
        }

        showConfirmDeleteModal(index: number): void {
            const devices = this.selectedSection.model.devices;

            const deleteDevice = devices[index];

            if (deleteDevice.drawerId != null &&
                deleteDevice.deviceType == DeviceTypeEnum.PosStation) {
                this.modalService.warning("You are about to delete a POS Station that is linked to a drawer.  Deleting this POS Station will unlink it from the drawer.  Do you want to continue? ", 0, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                    .then(() => {
                    if (deleteDevice.id != null) {
                        deleteDevice.objectState = Meevo.Model.ObjectStateEnum.Deleted;
                    } else {
                        devices.splice(index, 1);
                    }
                });
            }
            else {
                this.modalService.warning("Do you want to delete this? ", 0, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                    .then(() => {
                    if (deleteDevice.id != null) {
                        deleteDevice.objectState = Meevo.Model.ObjectStateEnum.Deleted;
                    } else {
                        devices.splice(index, 1);
                    }
                });
            }
        }

        createPrinterDetail(
            deviceIp: string,
            devicePort: string,
            deviceId: Guid,
            deviceName: string,
            ribbonSize: number,
            brandId: number,
            isTrustEnabled: boolean = true,
            isCustomerDisplayEnabled: boolean = false,
            standbyMessageLine1: string = null,
            standbyMessageLine2: string = null
        ): Meevo.Components.Common.IPrintServicePrinter {
            const printerDetail: Meevo.Components.Common.IPrintServicePrinter = {
                brandId: brandId,
                displayName: deviceName,
                deviceName: deviceName,
                ribbonSize: +ribbonSize,
                id: deviceId,
                ipAddress: deviceIp,
                port: Number(devicePort),
                isTrustEnabled: isTrustEnabled,
                isCustomerDisplayEnabled: isCustomerDisplayEnabled,
                customerDisplayStandbyLine1: standbyMessageLine1,
                customerDisplayStandbyLine2: standbyMessageLine2,
            };
            return printerDetail;
        }

        communicateWithPrinter(device: any): void {
            const printerDetail = this.createPrinterDetail(device.ipAddress, device.port, device.id, device.deviceName, device.ribbonSize, device.brandId, device.isTrustEnabled);
            this.printService.printToDevice(printerDetail, "/api/receipt/testtemplate/").catch(() => {
                //this.modalService.alert("MESSAGE_UNABLE_TO_CONNECT_TO_PRINTER");
            });
        }

        setCustomerDisplayText(
            deviceIp: string,
            devicePort: string,
            deviceId: Guid,
            deviceName: string,
            ribbonSize: number,
            brandId: number,
            isTrustEnabled: boolean,
            displayTextLine1: string,
            displayTextLine2: string,
            isCustomerDisplayEnabled: boolean
        ): void {
            const printerDetail = this.createPrinterDetail(deviceIp, devicePort, deviceId, deviceName, ribbonSize, brandId, isTrustEnabled, isCustomerDisplayEnabled);
            const message = {
                lines: [
                    { text: [displayTextLine1], alignment: Meevo.Components.Common.PoleDisplayAlignment.Spaced },
                    { text: [displayTextLine2], alignment: Meevo.Components.Common.PoleDisplayAlignment.Scrolling },
                ]
            }
            this.printService.queueMessagesToPoleDisplayToDevice(printerDetail, message);
        }

        openPrinterDrawer(
            deviceIp: string,
            devicePort: string,
            deviceId: Guid,
            deviceName: string,
            ribbonSize: number,
            brandId: number,
            isTrustEnabled: boolean): void {
            const printerDetail = this.createPrinterDetail(deviceIp, devicePort, deviceId, deviceName, ribbonSize, brandId, isTrustEnabled);
            this.printService.openDrawer(printerDetail).catch(() => {
                //this.modalService.alert("MESSAGE_UNABLE_TO_CONNECT_TO_PRINTER");
            });
        }

        protected buildCrudSecurityKeys(baseKey, hasCreateKey = false, hasCopyKey = false, hasChangeAccessKey = false, hasChangeOwnerKey = false) {
            this.addSecurityKey = baseKey + (hasCreateKey 
                ? Meevo.Components.Common.SecurityParts.KEY_PART_CREATE 
                : Meevo.Components.Common.SecurityParts.KEY_PART_WRITE);
                
            this.editSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;

            if (hasChangeAccessKey) {
                this.changeAccessSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_CHANGEACCESS;
            }
            if (hasChangeOwnerKey) {
                this.changeOwnerSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_CHANGEOWNER;
            }
        }

        isEpsonBrand(brandId: number): boolean {
            return (brandId === 1);
        }

        isStarBrand(brandId: number): boolean {
            return (brandId === 2);
        }

        isRibbonSizeVisible(brandId: number): boolean {
            return this.isStarBrand(brandId);
        }

        isDeviceNameVisible(brandId: number): boolean {
            return this.isEpsonBrand(brandId);
        }

        isPortVisible(brandId: number): boolean {
            return this.isEpsonBrand(brandId);
        }

        save(): angular.IPromise<any> {
            for (let i = 0; i < this.selectedSection.model.devices.length; i++) {
                if (this.selectedSection.model.devices[i].objectState === Meevo.Model.ObjectStateEnum.Active &&
                    this.selectedSection.model.devices[i].validState == false) {
                    this.modalService.alert("You are attempting to save devices with the same IP address. Please see your device documentation for instructions on locating each device's IP address.", null);

                    this.checkForm = true;
                    const deferred = this.$q.defer();
                    deferred.resolve("Successfully resolved the fake $http call");
                    return deferred.promise;
                }
            }

            if (this.canSave) {
                this.loadingInProgress = true;

                return this.dataService.customMethodData("/api/" + this.baseEndpoint, "POST", this.selectedSection.model)
                    .then((data: any) => {
                        this.selectedSection.model = data.data;
                        this.selectedSection.activate();
                        this.mode = Meevo.Model.MaintenanceFormState.Readonly;
                        this.loggingService.trace(`Updates saved.`);
                    })
                    .finally(() => {
                        this.loadingInProgress = false;
                        this.$rootScope.$broadcast(Meevo.Components.Common.Messages.POS_HARDWARE_UPDATED, this.$state.current);
                        this.postUpdate(this.selectedSection.model);
                    });
            }
            this.checkForm = false;
            return null;
        }

        isNullOrEmpty(param: any): boolean {
            return !param;
        }

        // override context common base so that we can assign proper keys to the meevo-secure directive
        selectSection(section: Meevo.Components.CommonClasses.ICommonSection) {
            if (this.selectedSection && this.selectedSection != section && this.navigationBlocked) {
                this.modalService.alert("MESSAGE_PENDING_CHANGES");
            } else {
                this.selectedSection = section;

                switch (section.displayNameContentKey) {
                    case "SECTION_POSHARDWARE_RECEIPTPRINER":
                        this.editSecurityKey = "REGISTER:POSHARDWARE:TAB:RECEIPTPRINTER:WRITE";
                        this.addSecurityKey = "REGISTER:POSHARDWARE:TAB:RECEIPTPRINTER:CREATE";
                        this.deleteSecurityKey = "REGISTER:POSHARDWARE:TAB:RECEIPTPRINTER:DELETE";
                        break;
                    case "SECTION_DRAWER_POS_STATIONS":
                        this.editSecurityKey = "REGISTER:POSHARDWARE:TAB:POSSTATION:WRITE";
                        this.addSecurityKey = "REGISTER:POSHARDWARE:TAB:POSSTATION:CREATE";
                        this.deleteSecurityKey = "REGISTER:POSHARDWARE:TAB:POSSTATION:DELETE";
                        break;
                }

                if (!this.selectedSection.isLoaded && !this.selectedSection.handlesOwnCrud) {
                    this.loadingInProgress = true;

                    this.dataService.getSection(this.baseEndpoint, this.selectedSection.sectionEndpoint)
                        .then((data: any) => {
                            this.selectedSection.model = data;
                            this.selectedSection.activate();

                            if (this.selectedSection.isPrimarySection) {
                                this.initializeHeader(data);
                            }

                        })
                        .finally(() => { 
                            this.loadingInProgress = false 
                        });
                }
                this.usageTrackingLog(Meevo.Model.VerbEnum.Viewed, null);
            }
        }
    }
}